import React from 'react';
import styles from './Test.module.scss';
import clsx from 'clsx';
import './static.css';
import { useState } from 'react';
import './static.css';
// const pos1 = { x: 20, y: 100 };
// const pos2 = { x: 20, y: 400 };
function Test() {
    // const [posBox1, setPosBox1] = useState(pos1);
    // const [posBox2] = useState(pos2);

    // const [box2Opacity, setBox2Opacity] = useState(0);

    const [visible, setVisible] = useState(true);

    // const handleClickBox1 = () => {
    //     console.log('handleClickBox1');
    //     setPosBox1(pos2);
    //     setBox2Opacity(100);
    // };

    // const handleClickBox2 = () => {
    //     console.log('handleClickBox2');
    //     setPosBox1(pos1);
    //     setBox2Opacity(0);
    // };

    const clickMe = () => {
        setVisible(false);
    };

    return (
        <>
            <button onClick={clickMe}>Click me</button>
            <div className={clsx(styles.wrapper)}>
                {/* <div
                className={clsx(styles.box1)}
                style={{
                    left: posBox1.x,
                    top: posBox1.y,
                }}
                onClick={handleClickBox1}
            ></div>

            <div
                className={clsx(styles.box2)}
                style={{
                    left: posBox2.x,
                    top: posBox2.y,
                    opacity: box2Opacity,
                    transitionDelay: box2Opacity === 0 ? '0s' : '1s',
                }}
                onClick={handleClickBox2}
            ></div> */}

                <div className={clsx(styles.box)}>1</div>
                {visible && <div className={clsx(styles.box)}></div>}
                <div className={clsx(styles.box)}>2</div>
                <div className={clsx(styles.box)}>3</div>
                <div className={clsx(styles.box)}>4</div>
                <div className={clsx(styles.box)}>5</div>
                <div className={clsx(styles.box)}>6</div>
                <div className={clsx(styles.box)}>7</div>
                <div className={clsx(styles.box)}>8</div>
            </div>
        </>
    );
}

export default Test;
